module.exports = __webpack_public_path__ + "img/1492113730.51060c70.jpg";